// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VeI4Y","name":"styles_name__3BvMq","phone":"styles_phone__nZoV1"};